// Libs
import React, { useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useTranslator from 'UTILS/hooks/useTranslator';
import { useSelector } from 'react-redux';

// Components
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import ClickToCallModal from 'COMPONENTS/ClickToCallModal';

// Utils
import translations from './locales.json';
import { onTrackedClick } from 'UTILS/callbacks';

const TopHeader = () => {
  const [translate] = useTranslator(translations);
  const supportPhoneNumber = useSelector(state => state.app.supportPhoneNumber);
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    onTrackedClick('open_need_help', 'header');
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    onTrackedClick('close_need_help', 'header');
    setIsOpen(false);
  };

  return (
    <>
      {supportPhoneNumber && (
        <ClickToCallModal open={isOpen} onClose={handleCloseModal} />
      )}
      <Box className='topHeader-container'>
        <Box className='topHeader-iconAndInfo' >
          <img src={theme.assets.appLogo} alt='logo acetiam' className='topHeader-logo' />
          <Typography variant='h6' color='primary' >{translate('teleconsultationSpace')}</Typography>
        </Box>
        {supportPhoneNumber && (
          <Chip color='primary' onClick={handleClick} variant='outlined' label={translate('needHelp')} icon={<HeadsetMicIcon className='topHeader-helpButtonIcon' />} />
        )}
      </Box>
    </>
  );
};

export default TopHeader;
